import { Box, Dialog, DialogActions, DialogContent } from '@mui/material';
import { CustomDialogTitle } from '../../../Modules/Common/Custom/CustomDialogTitle';
import { SmallLoading } from './Loading/IntermediateLoading';
import { MDBox } from "./MDBox";
import { MDButton } from './MDButton';
import { MDTypography } from "./MDTypography";

interface IProps {
    showDialog: boolean;
    heading: string;
    message: string;
    handleCancel: () => void;
    handleAccept: () => Promise<void>;
    isLoading?: boolean;
    loadingMessage?: string;
}

export const ConfirmationDialog = (props: IProps) => {

    return (
        <Dialog open={props.showDialog} onClose={props.handleCancel} aria-labelledby="form-dialog-title" maxWidth='sm'>
            <CustomDialogTitle id="customized-dialog-title" onClose={props.handleCancel}>
                {props.heading}
            </CustomDialogTitle>
            <DialogContent>
                <MDBox>
                    {props.isLoading && <SmallLoading />}
                    <MDTypography variant="button" fontWeight='regular' fontSize="0.9em" sx={{ whiteSpace: 'pre-line' }}>
                        {!props.isLoading ? props.message : props.loadingMessage}
                    </MDTypography>
                </MDBox>
            </DialogContent>
            {!props.isLoading &&
                <DialogActions>                    
                    <MDButton color="primary" variant="contained" onClick={props.handleAccept}>
                        Yes
                    </MDButton>
                    <MDButton color="secondary" variant="contained" onClick={props.handleCancel}>
                        No
                    </MDButton>
                </DialogActions>
            }
        </Dialog>
    )
}